import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

type Props = {
  page: number;
  setPage: (p: number | ((prev: number) => number)) => void;
  totalItems: number;
  pageSize: number;
  setPageSize: (size: number) => void;
  hasNext: boolean;
  loading?: boolean;
};

export default function CursorPagination({
  page,
  setPage,
  totalItems,
  pageSize,
  setPageSize,
  hasNext,
  loading = false,
}: Props) {

  const getRange = (size: number) => {
    if (totalItems === 0) return "0-0";

    const start = page * size + 1;
    const end = Math.min((page + 1) * size, totalItems);

    return `${start}-${end}`;
  };

  return (
    <div className="flex items-center gap-2 text-sm">

      {/* Same dropdown as old pagination */}
      <select
        value={pageSize}
        onChange={(e) => {
          setPageSize(Number(e.target.value));
          setPage(0);
        }}
        className="text-blue-500 font-semibold bg-transparent outline-none cursor-pointer"
      >
        {[10, 25, 50, 100].map((size) => (
          <option key={size} value={size}>
            {getRange(size)}
          </option>
        ))}
      </select>

      {/* Same total text */}
      <span className="text-gray-500">
        of {totalItems}
      </span>

      {/* Same prev button */}
      <button
        disabled={page === 0 || loading}
        onClick={() => setPage((p) => p - 1)}
        className="p-1.5 bg-gray-200 rounded disabled:opacity-40 disabled:cursor-not-allowed"
      >
        <FaChevronLeft size={12} />
      </button>

      {/* Same next button */}
      <button
        disabled={!hasNext || loading}
        onClick={() => setPage((p) => p + 1)}
        className="p-1.5 bg-blue-500 text-white rounded disabled:opacity-40 disabled:cursor-not-allowed"
      >
        <FaChevronRight size={12} />
      </button>
    </div>
  );
}
